import { useRef, useState } from "react";

// Guards a submit handler against double-fire (double-click, ghost tap on mobile,
// slow network + impatient re-click, etc.): `saving` state alone isn't enough
// since it only disables the button after a re-render, which isn't fast enough
// to stop two clicks in the same tick. The ref below blocks re-entry
// synchronously, before React ever gets involved.
export default function useGuardedSubmit() {
  const [saving, setSaving] = useState(false);
  const inFlight = useRef(false);
  const run = async (fn) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setSaving(true);
    try { await fn(); } finally { inFlight.current = false; setSaving(false); }
  };
  return [saving, run];
}
